import { useContext, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import { PublicRoute } from './PublicRoute';
import { PrivateRoute } from './PrivateRoute';
import { AuthRouter } from './AuthRouter';

import { DashboardPage } from '../components/pages/Dashboard';
import { AppContext } from '../context/AppContext';
import { ContentProvider } from '../context/ContentContext';

export const AppRouter = () => {
	const { user, resetLogin, logout } = useContext(AppContext);
	//	logout();
	useEffect(() => {
		user ? resetLogin() : logout();
	}, []);

	let activo = false;

	if (user) activo = true;

	console.log(activo);

	return (
		<BrowserRouter>
			<Routes>
				<Route
					path="/auth/*"
					element={
						<PublicRoute isAuthenticated={activo}>
							<AuthRouter />
						</PublicRoute>
					}
				/>
				<Route
					path="/"
					element={
						<PrivateRoute isAuthenticated={activo}>
							<ContentProvider>
								<DashboardPage />
							</ContentProvider>
						</PrivateRoute>
					}
				/>

				<Route path="/*" element={<Navigate to="/auth/singup" />} />
			</Routes>
		</BrowserRouter>
	);
};
